module.exports = __webpack_public_path__ + "static/img/eses.835615c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eses.png
// module id = psJ0
// module chunks = 0